<template>
  <div id="hrms55x">
    <hrms-search-box-table v-show="indexDisp && callFrom == 'hrms55x'"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms55xIndex"
            :csvExportDisp="true"
            :searchBoxAlias="callFrom"
            :callSearchEvent="callSearchEvent" />

    <hrms-table v-show="indexDisp && callFrom == 'hrms55x2'"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms55xIndex"
            :csvExportDisp="false"
            :searchBoxAlias="callFrom"
            :callSearchEvent="callSearchEvent" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms55x/mutation-types'
import moment from 'moment'

export default {
  name: 'hrms55x',
  props: {
    callFrom: {
      type: String,
      default: 'hrms55x'
    },
    dateWork: {
      type: String
    }
  },
  data () {
    return {
      dash: this.$root.$children[0],
      searchIndex: {
        dteworkst: moment().format('01/01/YYYY'),
        dteworken: moment().format('DD/MM/YYYY')
      },
      currCodApp: this.$root.$children[0].$children[0].codapp
    }
  },
  watch: {
    dateWork () {
      this.searchIndex.dtework = this.dateWork
      let searchParams = {}
      searchParams['dtework'] = this.dateWork
      searchParams['codapp'] = this.currCodApp
      this.receivedHrms55x2Index(searchParams)
    }
  },
  created () {
    this.receivedHrms55xColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS55X_INDEX_DISP,
      columns: types.GET_HRMS55X_COLUMNS,
      labels: types.GET_HRMS55X_LABELS,
      index: types.GET_HRMS55X_INDEX
    })
  },
  methods: {
    callSearchEvent () {
      if (this.searchIndex.codempid4 !== '') {
        this.searchIndex.codcomp2 = ''
      }
      this.searchIndex['codapp'] = this.currCodApp
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS55X_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS55X_PAGE,
      receivedHrms55xColumnsLabels: types.RECEIVED_HRMS55X_COLUMNS_LABELS,
      receivedHrms55xIndex: types.RECEIVED_HRMS55X_INDEX,
      receivedHrms55x2Index: types.RECEIVED_HRMS55X2_INDEX
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?0a86f5a0